import React from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";

const Lnb = styled.nav`
  height: 50px;
  background: #02348b;
  color: #fff;
`;

const Ul = styled.ul`
  height: 100%;
  &:after {
    display: block;
    clear: both;
    content: "";
  }
`;

const Li = styled.li`
  float: left;
  height: 100%;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 25px;
  color: #fff;
  white-space: pre-line;

  &:hover,
  &.on {
    background: #118ccf;
  }
`;

const NavLnb = ({ location, urlData }) => {
  return (
    <Lnb>
      <div className="inr">
        <Ul>
          {urlData === null ? (
            <li></li>
          ) : (
            urlData.map(item => {
              return (
                <Li key={item.id}>
                  <StyledLink
                    to={item.url}
                    className={
                      item.url === location.pathname ||
                      item.view === location.pathname ||
                      item.write === location.pathname ||
                      item.write2 === location.pathname
                        ? "on"
                        : ""
                    }
                  >
                    {item.name}
                  </StyledLink>
                </Li>
              );
            })
          )}
        </Ul>
      </div>
    </Lnb>
  );
};

export default withRouter(NavLnb);
